<template>
    <div>
        statistics
    </div>
  </template>
  
  <script>


  export default {
    name: 'Statistics',
    components: {

    },
    data() {
      return {
        loadData: [],
      }
    },
    mounted: function () {

    },
    methods: {

    },
  }
  </script>

  